import { IconButton, Menu } from '@material-ui/core';
import ThemedMenuItem from 'common/ThemedMenuItem';
import { MoreVert as Options } from '@material-ui/icons';
import React, { memo, useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderSpecificationContext } from './OrderSpecificationProvider';
const OrderModelButton = ({ handleRemoveOrderModel, goToSpecificationSummary, specId, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuOpen = useCallback((e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setAnchorEl(e === null || e === void 0 ? void 0 : e.currentTarget);
    }, []);
    const handleMenuClose = useCallback((e) => {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setAnchorEl(null);
    }, []);
    const onRemoveOrderModel = useCallback((modelSpecId) => () => {
        handleRemoveOrderModel(modelSpecId);
    }, [handleRemoveOrderModel]);
    const onGoToSpecificationSummary = useCallback((modelSpecId) => () => {
        goToSpecificationSummary(modelSpecId);
    }, [goToSpecificationSummary]);
    const { t } = useTranslation('orders');
    const { order } = useContext(OrderSpecificationContext);
    return (React.createElement("div", null,
        React.createElement(IconButton, { className: "options-icon", size: "small", onClick: handleMenuOpen },
            React.createElement(Options, null)),
        React.createElement(Menu, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleMenuClose },
            React.createElement(ThemedMenuItem, { onClick: onGoToSpecificationSummary(specId), text: t('go_to_specification') }),
            React.createElement(ThemedMenuItem, { onClick: onRemoveOrderModel(specId), text: t('remove_from_orders'), disabled: (order === null || order === void 0 ? void 0 : order.status) !== 'DRAFT' }))));
};
export default memo(OrderModelButton);
